import React from 'react'
import { Box, Avatar, Paper, Typography} from '@mui/material';


const Message = ({ message }) => {

    const isBot = message.sender === "app_client";

  return (
        <><Box
      sx={{
        display: "flex",
        justifyContent: isBot ? "flex-start" : "flex-end",
        mb: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isBot ? "row" : "row-reverse",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ height: '30px', width: '30px', bgcolor: isBot ? "secondary.main" : "primary.main" }}>
          {isBot ? "T" : "S"}
        </Avatar>
        <Paper
          variant="outlined"
          sx={{
            p: 1,
            ml: isBot ? 1 : 0,
            mr: isBot ? 0 : 1,
            backgroundColor: isBot ? "#e5e5ea" : "#0b93f6",
            borderRadius: isBot ? "20px 20px 20px 5px" : "20px 20px 5px 20px",
          }}
        >
          <Typography sx={{ fontSize: '0.75rem',wordBreak: 'break-word' }} color={isBot ? "#000" : "#ffffff"} variant="body1">{message.message_text}</Typography>

        </Paper>

      </Box>
    </Box><Box
      sx={{
        display: "flex",
        justifyContent: isBot ? "flex-start" : "flex-end",
        mb: 1,
      }}
    >
        <Typography sx={{ color:'#bbb',fontSize: '0.60rem',marginLeft:'38px',marginRight:'38px' }} variant="body1">{message?.timestamp}</Typography>
      </Box></>
  )
}

export default Message